const CHILD_DATE_INPUT_LENGTH = 10;
const MAX_TOUR_CHILD_AGE = 11;
const TOUR_CHILD_DATE_REGEX = /^(\d{2})\/(\d{2})\/(\d{4})$/;

export const isCompleteTourChildDateInput = (dateString: string): boolean =>
  dateString.length === CHILD_DATE_INPUT_LENGTH;

export const parseTourChildDate = (dateString: string): Date | null => {
  const match = TOUR_CHILD_DATE_REGEX.exec(dateString);
  if (!match) return null;

  const [, dayText, monthText, yearText] = match;
  const day = Number(dayText);
  const month = Number(monthText) - 1;
  const year = Number(yearText);
  const date = new Date(year, month, day);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month ||
    date.getDate() !== day ||
    date > new Date()
  ) {
    return null;
  }

  const today = new Date();
  let age = today.getFullYear() - year;
  if (
    today.getMonth() < month ||
    (today.getMonth() === month && today.getDate() < day)
  ) {
    age -= 1;
  }

  return age <= MAX_TOUR_CHILD_AGE ? date : null;
};

export const isValidTourChildDate = (dateString: string): boolean =>
  isCompleteTourChildDateInput(dateString) &&
  parseTourChildDate(dateString) !== null;
